module.exports = __webpack_public_path__ + "static/img/RWB-48V5A_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWB-48V5A_1.png
// module id = zvsE
// module chunks = 0